import lockupUrl from '@/assets/brand/velko-lockup.svg';
import markUrl from '@/assets/brand/velko-mark.svg';
import wordmarkUrl from '@/assets/brand/velko-wordmark.svg';

const BASE_URL = import.meta.env.BASE_URL ?? '/';

function withBase(path: string): string {
  const normalizedBase = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  const normalizedPath = path.replace(/^\//, '');
  return `${normalizedBase}${normalizedPath}`;
}

export const BRAND = {
  name: 'Velko',
  shortName: 'Velko',
  productName: 'Velko POS',
  url: 'https://velko-pos.com',
  email: 'contact@velko-pos.com',
  phone: '+237656488879',
  tagline: {
    fr: 'Le commerce avance, meme hors ligne.',
    en: 'Commerce that moves, even offline.',
  },
  // Profils officiels publics — alimentent `sameAs` (réconciliation d'entité pour
  // Google Knowledge Graph + moteurs IA). N'AJOUTER QUE des profils réellement
  // existants : un `sameAs` mort affaiblit l'entité au lieu de la renforcer.
  social: {
    facebook: 'https://www.facebook.com/velkopos.sarl',
    twitter: 'https://twitter.com/VelkoPOS',
    tiktok: 'https://www.tiktok.com/@velkopos4',
    // À compléter quand les comptes existent :
    // instagram: 'https://www.instagram.com/...',
    // linkedin: 'https://www.linkedin.com/company/...',
    // youtube: 'https://www.youtube.com/@...',
  },
  assets: {
    mark: markUrl,
    wordmark: wordmarkUrl,
    lockup: lockupUrl,
    favicon: withBase('/brand/velko-favicon.svg'),
  },
} as const;

/** URLs `sameAs` dérivées des profils officiels (Organization + auteurs). */
export const BRAND_SAMEAS: string[] = Object.values(BRAND.social);

/** URL absolue du logo (lockup), utilisée dans les schémas Organization/publisher. */
export const BRAND_LOGO_URL = `${BRAND.url}/brand/velko-lockup.svg`;
